import { imageMediaViewPorts } from '@/constants/image';
import { Media } from '@cinemark/content-api-client';
import Image from 'next/image';

type BenefitType = 'movie-fan' | 'movie-club';

type BenefitProps = {
  benefitIndex: number;
  header?: string;
  image?: Media;
  imageSmall?: Media;
  text?: string;
  type: BenefitType;
};

export const Benefit = ({ benefitIndex, header, image, imageSmall, text, type }: BenefitProps): React.JSX.Element | null => {
  if (!image?.url && !imageSmall?.url && !header && !text) return null;

  const altText = type === 'movie-fan' ? 'Movie Fan' : 'Movie Club';

  return (
    <div className="flex gap-ms items-center w-auto md:w-1/3 md:flex-col md:justify-between">
      {(imageSmall?.url || image?.url) &&
        <picture className="max-w-12 md:max-w-none">
          <source media={imageMediaViewPorts.maxLarge}
            srcSet={imageSmall?.url || ''}
          />
          <Image alt={`${altText} Benefit ${benefitIndex}`}
            height={image?.height || 0}
            src={image?.url || ''}
            width={image?.width || 0}
          />
        </picture>
      }

      {(header || text) &&
        <div className="md:text-center">
          {header && <p data-test={`${type}-benefits-header-${benefitIndex}`}>{header}</p>}
          {text && <p data-test={`${type}-benefits-text-${benefitIndex}`}>{text}</p>}
        </div>
      }
    </div>
  );
};
